<div class="container-fluid mt-3 ">
    <div class="row justify-content-center">
        <span class="col-12 text-center">
            Adduction
        </span>
    </div>

    <div class="row rounded-1 background-light mt-3 mb-3 py-3">
        <mat-form-field class="col">
            <mat-label>Code</mat-label>
            <input matInput [(ngModel)]="Model.Code" placeholder="Code" disabled>
        </mat-form-field>
    </div>

    <div class="row rounded-1 background-light mt-3 mb-3 py-3">

        <div class="col">
            <mat-form-field class="w-100">
                <mat-label>Date </mat-label>
                <input matInput placeholder="Date de changement du filtre" [matDatepicker]="picker" [(ngModel)]="Date" (click)="picker.open()" (dateChange)="dateChanged($event)">
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
        </div>

        <div class="col">
            <mat-form-field class="w-100">
                <mat-label>Appareil Mesure</mat-label>
                <input matInput [(ngModel)]="Model.AppareilMesure" placeholder="Appareil Mesure">
            </mat-form-field>
        </div>

        <div class="col">
            <mat-form-field class="w-100">
                <mat-label>Localisation</mat-label>
                <input matInput [(ngModel)]="Model.Localisation" placeholder="Localisation">
            </mat-form-field>
        </div>

        <div class="col">
            <mat-form-field class="w-100">
                <mat-label>Observation</mat-label>
                <textarea matInput [(ngModel)]="Model.Observation" placeholder="Observation"></textarea>
            </mat-form-field>
        </div>

    </div>

    <div class="row rounded-1 background-light mt-3 mb-3 py-3">
        @if (Model.MaterielAdductionAirList.length > 0) {
        <div class="col">

            @for (materiel of Model.MaterielAdductionAirList; track materiel) {
            <div class="row border rounded-1 m-1 p-1" style="background-color: burlywood;">
                <div class="col text-center">
                    <div class="row">
                        <div class="col-1"></div>
                        <div class="col">{{getMaterialName(materiel.Type)}}</div>
                        <a class="col-auto btn-close me-1" (click)="deleteMateriel(materiel)"></a>
                    </div>
                    <div class="row">
                        <div class="col">{{materiel.Fabricant}}</div>
                    </div>
                    <div class="row">
                        <div class="col">{{materiel.Reference}}</div>
                    </div>
                    <div class="row">
                        <div class="col">{{materiel.MaterielCompresseur.ReferenceHuile}}</div>
                    </div>
                    <div class="row">
                        <div class="col">{{materiel.Description}}</div>
                    </div>
                </div>
            </div>
            }
        </div>
        }
        <span class="row justify-content-center mb-3">
            <button class="ms-3 col-auto ps-3" color="primary" mat-raised-button (click)="addMateriel()">
                <mat-icon class="material-symbols-outlined">add</mat-icon> Nouveau Materiel
            </button>
        </span>
    </div>

    <div class="row rounded-1 background-light mt-3 mb-3 py-3">
        <div class="col">
            @for (prel of Model.PrelevementAirList; track prel) {
            <div class="row border rounded-1 m-1 p-1" style="background-color: cornflowerblue;">
                <div class="col text-center">
                    <div class="row">
                        <div class="col-1"></div>
                        <div class="col">{{getPrelevementAdductionName(prel.Type)}}</div>
                        <a class="col-auto btn-close me-1" (click)="deletePrelevementAir(prel)"></a>
                    </div>
                    <div class="row">
                        <div class="col">{{prel.Duree}}</div>
                    </div>
                    <div class="row">
                        <div class="col">{{prel.ReferenceTube}}</div>
                    </div>
                    <div class="row">
                        <div class="col">{{prel.Resultat}}</div>
                    </div>
                    <div class="row">
                        <div class="col"><mat-slide-toggle class="m-1" [(ngModel)]="prel.Conformite" disabled>Conformité</mat-slide-toggle></div>
                    </div>
                </div>
            </div>
            }
        </div>
        <span class="row justify-content-center mb-3">
            <button class="ms-3 col-auto ps-3" color="primary" mat-raised-button (click)="addPrelevement()">
                <mat-icon class="material-symbols-outlined">add</mat-icon> Nouveau Prelevement
            </button>
        </span>
    </div>

    <div class="row my-3">
        <button appPreventDoubleClick class="col" color="warn" mat-raised-button (throttledClick)="cancelMeasure()">
            Mesure non réalisée
        </button>
    </div>
    <div class="row">
        <button appPreventDoubleClick class="col" color="primary" mat-raised-button (throttledClick)="save()">
            Enregistrer
        </button>
    </div>
</div>